// https://www.mediaevent.de/javascript/intersection-observer.html
S.animation = {
    config: {
        threshold: 0.5,
    },

    elements: {},

    init()
    {
        this.animationClass();
        this.animationClassCustom();
    },

    observeInit(jadeScale, style, repeat, options)
    {
        // const jadeScaleObserver = new IntersectionObserver((entries, observer) =>
        const jadeScaleObserver = new IntersectionObserver((entries) =>
        {
            entries.forEach((entry) =>
            {
                if (entry.isIntersecting)
                {
                    entry.target.classList.add(style);
                }
                else if (repeat === true)
                {
                    // das geht so nur bei bestimmten Animationen z.B. Kreis im Bild, links rechts einfahren etc.
                    // weil die Animation wird auch ausgeführt wenn man nach oben scrollt
                    // bei top Animationen kommt es zum flackern
                    // console.log(style);
                    entry.target.classList.remove(style);
                }
            });
        }, options);

        jadeScale.forEach((jadeScale) =>
        {
            jadeScaleObserver.observe(jadeScale);
        });
    },

    getOptions(threshold)
    {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: threshold,
        };

        return options;
    },

    animationClass()
    {
        const options = this.getOptions(this.config.threshold);
        const repeat = false;
        const value = 'has-animation';

        // console.log(this.$module.attr('class').split(' ')[0]);

        const selector = '.' + this.$module.attr('class').split(' ')[0];
        const jadeScale = document.querySelectorAll(selector);

        // console.log(selector);
        this.observeInit(jadeScale, value, repeat, options);
    },

    animationClassCustom()
    {
        // console.log(this.config.rootMargin);
        let options = this.getOptions(this.config.threshold);
        let repeat = false;
        const vars = JSON.stringify(this.$module.data('js-animation'));

        JSON.parse(vars, (key, value) =>
        {
            if (typeof value === 'string' && value !== '' && key !== '')
            {
                // console.log(key + ':' + value);

                // repeat?
                if (value.slice(-1) === '+')
                {
                    repeat = true;
                    value = value.slice(0, -1);

                    // klappt nicht
                    // options = this.getOptions(0);
                }

                // console.log(this.$module.attr('class').split(' ')[0]);
                const selector = '.' + this.$module.attr('class').split(' ')[0] + ' .' + key;

                // console.log(selector);
                const jadeScale = document.querySelectorAll(selector);

                this.observeInit(jadeScale, value, repeat, options);
            }
        });
    },
};
